<template>
	<div>
		<ArvandUserLoanPaymentPrintHtml :userLoanPayment="userLoanPayment" :member="member" :area="area" @ready="$emit('ready')" />
	</div>
</template>

<script>
import { get } from 'vuex-pathify'
import api from '@/util/app-api'
import toast from '@/util/toast'
import { sumBy } from 'lodash'

export default {
	name: 'DefaultUserLoanPaymentPrintHtml',
	components: {
		ArvandUserLoanPaymentPrintHtml: () => import('./UserLoanPaymentPrints/ArvandUserLoanPaymentPrintHtml'),
	},
	props: {
		userLoanPayment: {
			type: Object,
		},
		member: {
			type: Object,
		},
		area: {
			type: String,
			default: 'admin'
		}
	},
	data: () => ({

	}),
	mounted() {

	},
	computed: {
		...get('auth', [
			'getCurrentUser',
		]),
		customerCode() {
			var user = this.getCurrentUser
			if (user && user.userData && user.userData.customer) { return `${user.userData.customer.code}` }
			return ''
		},
	},
	methods: {

	}
}
</script>
<style scoped></style>